<template>
  <index />
</template>

<script>
import appConfig from '@/app.config'
import Index from '../../../components/list/index.vue'

export default {
  page: {
    title: 'مدیریت صدور مدرک',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillUp-issuance-certificate',
  components: { Index },
}
</script>
